import { render, staticRenderFns } from "./AddPhilosophy.vue?vue&type=template&id=0d091bac&scoped=true&"
import script from "./AddPhilosophy.vue?vue&type=script&lang=js&"
export * from "./AddPhilosophy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d091bac",
  null
  
)

export default component.exports